import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-darker text-gray-300 pt-16 pb-8 border-t border-white/10" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-61">
          {/* Company Info */}
          <div className="space-y-6" data-id="element-62">
            <div className="flex flex-col items-start" data-id="element-63">
              <div className="flex items-center text-2xl font-heading font-extrabold tracking-tight" data-id="element-64">
                <span className="text-white" data-id="element-65">RAPID</span>
                <span className="text-brand-green italic ml-1" data-id="element-66">ENERGY</span>
              </div>
              <span className="text-[10px] text-gray-400 uppercase tracking-widest mt-1 font-medium" data-id="element-67">
                Your Critical Asset Hire Partner
              </span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400" data-id="element-68">
              Established in February 2020, Rapid Energy is a forward thinking,
              ambitious business operating in the UK temporary heating and
              cooling sector.
            </p>
            <div className="flex space-x-4" data-id="element-69">
              <a href="#" className="text-gray-400 hover:text-brand-green transition-colors" data-id="element-70">
                <Linkedin className="w-5 h-5" data-id="element-71" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-green transition-colors" data-id="element-72">
                <Twitter className="w-5 h-5" data-id="element-73" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-green transition-colors" data-id="element-74">
                <Facebook className="w-5 h-5" data-id="element-75" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-green transition-colors" data-id="element-76">
                <Instagram className="w-5 h-5" data-id="element-77" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-78">
            <h3 className="text-white font-heading font-bold text-lg mb-6 flex items-center" data-id="element-79">
              <span className="w-2 h-2 bg-brand-green mr-3 rounded-full" data-id="element-80"></span>
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-81">
              {['About Us', 'Blog', 'Careers', 'Depot Locations', 'Contact Us'].map(link => <li key={link} data-id="element-82">
                  <Link to={link === 'About Us' ? '/about' : link === 'Contact Us' ? '/contact' : '#'} className="text-sm hover:text-brand-green transition-colors flex items-center" data-id="element-83">
                    <span className="mr-2 text-brand-green/50" data-id="element-84">›</span> {link}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-85">
            <h3 className="text-white font-heading font-bold text-lg mb-6 flex items-center" data-id="element-86">
              <span className="w-2 h-2 bg-brand-green mr-3 rounded-full" data-id="element-87"></span>
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-88">
              {[{
              name: 'Boiler Hire',
              path: '/boiler-hire'
            }, {
              name: 'Heater Hire',
              path: '/heater-hire'
            }, {
              name: 'Chiller Hire',
              path: '/chiller-hire'
            }, {
              name: 'Cooling Hire',
              path: '/cooling-hire'
            }, {
              name: 'Ancillaries',
              path: '/ancillaries'
            }, {
              name: 'Industry Sectors',
              path: '/services'
            }].map(link => <li key={link.name} data-id="element-89">
                  <Link to={link.path} className="text-sm hover:text-brand-green transition-colors flex items-center" data-id="element-90">
                    <span className="mr-2 text-brand-green/50" data-id="element-91">›</span>{' '}
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-92">
            <h3 className="text-white font-heading font-bold text-lg mb-6 flex items-center" data-id="element-93">
              <span className="w-2 h-2 bg-brand-green mr-3 rounded-full" data-id="element-94"></span>
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-95">
              <li className="flex items-start" data-id="element-96">
                <Phone className="w-5 h-5 text-brand-green mr-3 mt-0.5 flex-shrink-0" data-id="element-97" />
                <div data-id="element-98">
                  <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-99">
                    24/7 Support
                  </span>
                  <a href="tel:08004647025" className="text-white font-bold hover:text-brand-green transition-colors" data-id="element-100">
                    0800 464 7025
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-101">
                <Mail className="w-5 h-5 text-brand-green mr-3 mt-0.5 flex-shrink-0" data-id="element-102" />
                <div data-id="element-103">
                  <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-104">
                    Email Us
                  </span>
                  <a href="mailto:info@rapidenergy.co.uk" className="text-sm hover:text-brand-green transition-colors" data-id="element-105">
                    info@rapidenergy.co.uk
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-106">
                <MapPin className="w-5 h-5 text-brand-green mr-3 mt-0.5 flex-shrink-0" data-id="element-107" />
                <div data-id="element-108">
                  <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-109">
                    Head Office
                  </span>
                  <span className="text-sm text-gray-400" data-id="element-110">
                    Nationwide Coverage
                    <br data-id="element-111" />
                    United Kingdom
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-112">
          <p data-id="element-113">
            &copy; {new Date().getFullYear()} Rapid Energy. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-114">
            <a href="#" className="hover:text-white transition-colors" data-id="element-115">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-116">
              Terms & Conditions
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-117">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}